import React, {Component} from 'react'
import {observer} from 'mobx-react'

@observer export default class ErrorPageComponent extends Component {
    render() {
        const {profile_menu_id} = this.props

        const hide_profiles_tab_css = `
#${profile_menu_id} {
	display: none !important;
}
`

        return (
            <div>
                <style dangerouslySetInnerHTML={{__html: hide_profiles_tab_css}}/>

                Произошла ошибка. Обратитесь к разработчику плагина.
            </div>
        )
    }
}